import { render } from "./CustomerBpmCard.vue?vue&type=template&id=a05bc90e"
import script from "./CustomerBpmCard.vue?vue&type=script&lang=js"
export * from "./CustomerBpmCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__